var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"active":"admin_logs"}}),_c('CrudList',{attrs:{"tableName":"admin_log","tableNamePlural":"admin_logs","queryParams":"?join=admin_user&order=id,desc&size=250","defaultSort":"id","defaultSortDirection":"desc","showAddButton":false,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }